<template>
  <div class="pull-height animated" :class="{'zoomOutUp': isLock}">
    <div class="mask" v-if="mask">
      <div class="mask-con">
        <img src="../../assets/img/loading.svg" alt="" />
      </div>
    </div>
    <div class="index">
      <sidebar />
      <div :class="{ 'hide-sidebar': isCollapse }" style="min-width:calc(100vw - 210px);flex: 1;max-width: calc(100vw - 64px)">
        <div class="nav">
          <top class="top" @openUpdatePwd="openUpdatePwd" @isMask="isMask" />
        </div>
        <div class="main" ref="ciicMainBox">
          <keep-alive>
            <router-view ref="ciicMain" @toTop="scrolltop" v-if="$route.meta.keepAlive && isRouterAlive" />
          </keep-alive>
          <router-view ref="ciicMain" @toTop="scrolltop" v-if="!$route.meta.keepAlive && isRouterAlive" />
          <!--<div class="router" id="main" ref="ciicMain" :class="{ 'auto-height': $route.path == '/index' }">-->
          <!---->
          <!--</div>-->
        </div>
      </div>
    </div>
    <div>
      <update-pwd :is-show="showUpdatePassword" show-close title="找回密码" @closeUpdatePwd="closeUpdatePwd" />
    </div>
  </div>
</template>

<script>
  import updatePwd from './updatePwd.vue';
  import {
    checkUser
  } from '@/api/user/login';
  import { mapGetters } from "vuex";
  import top from "./top/index";
  import sidebar from "./sidebar/index";
  export default {
    components: {
      top,
      sidebar,
      updatePwd
    },
    name: "Index",
    data() {
      return {
        title: "修改密码",
        showClose: true,
        isUpdate: false,
        isRouterAlive: true,
        dicts: {},
        mask:false,
      };
    },
    created() {
      document.documentElement.style.fontSize = '14px';
      this.getDicts().then((res) => {
        this.dicts = res.data.data;
        this.$store.commit("SET_DICTS", this.dicts);
      });
    },
    mounted() {
      // 主题 light-theme/白  dark-theme/黑
      if (typeof(localStorage.Theme) == "undefined") {
        localStorage.setItem("Theme", "light-theme");
        localStorage.setItem("Color", "#000000");
      }
      document.getElementsByTagName("body")[0].className = localStorage.getItem("Theme");
      this.$store.commit("SET_WORKSPACE_RECT", this.$refs.ciicMain);

    },
    computed: mapGetters(["isLock", "userInfo", "accessToken", "showUpdatePassword", "isCollapse"]),
    props: [],
    provide() {
      return {
        reload: this.reload
      };
    },
    methods: {
      closeUpdatePwd() {
        const { updatePassword } = this.userInfo;
        if (updatePassword === true) {
          this.$router.push('/login');
        } else {
          this.$store.commit('SHOW_UPDATE_PASSWORD', false)
        }
        this.title = '修改密码'
      },
      openUpdatePwd() {
        this.$store.commit('SHOW_UPDATE_PASSWORD', true)
      },
      reload() {
        this.isRouterAlive = false;
        this.$nextTick(function() {
          this.isRouterAlive = true;
        });
      },
      // 回到顶部
      scrolltop() {
        this.$refs.ciicMainBox.scrollTop = 0;
      },
      //遮罩层
      isMask(data){
        this.mask = data
      }
    }
  };
</script>

<style lang="scss" scoped>

#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  text-align: center;
  color: #2c3e50;
  margin-top: 60px;
}

.mask{
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.25);
  position: absolute;
  left: 0;
  top: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  .mask-con{
    width: 30%;
    height: 30%;
    // background: url('../../assets/img/loading.svg') no-repeat;
    img{
      width: 100%;
      height: 100%;
    }
  }
}
  .index {
    display: flex;
    position: relative;
    overflow: hidden;
    height: 100%;
    .main {
      padding: 15px;
      box-sizing: border-box;
      overflow-y: auto;
      height: calc(100vh - 61px);
    }
    .nav {
      box-shadow: 0 0 1px rgba(0, 0, 0, 0.25);
    }
    .top {
      height: 60px;
    }
  }
</style>
